module.exports = __webpack_public_path__ + "static/media/siddharth-big-banyan-tree-trip-05.24d8d894.png";